import React, { Component } from 'react';

export default class signatureTemplate extends Component {

	constructor(props) {
		super(props);
		this.state = {
			output: null,
		}
	}

	componentDidMount() {
		this.setState({
			output: this.template.outerHTML,
		});
	}

	componentDidUpdate() {
		if (this.state.output !== this.template.outerHTML) {
			this.setState({
				output: this.template.outerHTML, 
			}); 
		}
	}

	_signatureTemplate = () => {
		return (
			<table ref={(c) => this.template = c}>
				<tbody>
					<tr>
						<td width="70">
							<img src="https://freeatheart.de/static/logo.png" width="70" style={{ width: '70px' }} alt="logo" />
						</td>
						<td width="200">
							<p style={{ fontFamily: 'Helvetica, sans-serif', fontSize: '12px', lineHeight: '16px' }}>
								<b>{this.props.name}</b>
								<br /> <i>FreeatHeart Deutschland e.V. </i>
								<br /> 
								<span style={{whiteSpace: 'nowrap'}}>
									{this.props.email}
								</span>
								<br /> {this.props.phone}
							</p>
						</td>
					</tr>
				</tbody>
			</table>
		);
	}

	render() {
		return (
			<div className={'shadowbox signature-preview'} >
				<div>
					<h2>Signaturvorschau</h2>
					{this._signatureTemplate()}
				</div>
				<h2>HTML-Signatur</h2>
				<p>Der unten angezeigte Code kann in verschiedenste Mailprogramme integriert werden:</p>
				<code>
					{this.state.output}
				</code>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/signatureOutput.js